// Import utilities
import {
	addParametersToURL,
	isEmpty
} from '@automator/utilities';

/**
 * Adds the UTM parameters to a given URL for tracking and analytics purposes.
 *
 * @param {String} url - The base URL to which UTM parameters will be appended.
 * @param {Object} parameters - An object containing UTM parameters to add to the URL.
 * @param {String} parameters.medium - Specifies the "utm_medium" parameter, which typically identifies the marketing medium (e.g., "email", "social", "cpc"). Provide a string that clearly describes the traffic source.
 * @param {String} parameters.campaign - Specifies the "utm_campaign" parameter, which identifies the campaign name or identifier (e.g., "spring_sale", "newsletter_march"). Use a string that corresponds to the campaign you're tracking.
 * @param {String} parameters.content - Specifies the "utm_content" parameter, used to differentiate similar content within the same campaign (e.g., "cta_button", "text_link"). This is optional but helps track specific links or placements within a campaign.
 * @return {String} - The resulting URL with appended UTM parameters for analytics tracking.
 */
const addParametersUTM = ( url, { medium, campaign, content } ) => {
	// Define the parameters we're going to add
	const urlParameters = {};

	// Add the utm_source
	// eslint-disable-next-line camelcase
	urlParameters.utm_source = UncannyAutomatorBackend._site.automator.plan_details.is_pro_installed ? 'uncanny_automator_pro' : 'uncanny_automator';

	// Add the medium
	if ( ! isEmpty( medium ) ) {
		// eslint-disable-next-line camelcase
		urlParameters.utm_medium = medium;
	}

	// Add the campaign
	if ( ! isEmpty( campaign ) ) {
		// eslint-disable-next-line camelcase
		urlParameters.utm_campaign = campaign;
	}

	// Add the content
	if ( ! isEmpty( content ) ) {
		// eslint-disable-next-line camelcase
		urlParameters.utm_content = content;
	}

	// Check if we have to add the utm_r parameter
	if ( ! isEmpty( UncannyAutomatorBackend._site.automator.marketing_referer ) ) {
		// eslint-disable-next-line camelcase
		urlParameters.utm_r = UncannyAutomatorBackend._site.automator.marketing_referer;
	}

	// Add the parameters
	url = addParametersToURL( url, urlParameters );

	// Return the modified URL
	return url;
};

export default addParametersUTM;